import React from "react";
import DomeGallery from "./DomeGallery";
import useExploreMoviePool from "./useExploreMoviePool";

/**
 * Standalone Explore page, mounted at /explore via App.js's router.
 * Previously this lived as internal `currentView === "explore"` state
 * inside EntertainmentRecommender with no dedicated URL; extracted here
 * so it gets a real, shareable/bookmarkable route like the other top-level
 * pages (e.g. /cookies, /privacy).
 */
export default function Explore() {
  const { movies: exploreMovies } = useExploreMoviePool();

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "#000",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "max(1.25rem, env(safe-area-inset-top, 0px))",
          left: "max(1.25rem, env(safe-area-inset-left, 0px))",
          zIndex: 50,
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 1rem",
          background: "#fff",
          borderRadius: "9999px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
          cursor: "pointer",
        }}
        onClick={() => {
          window.location.href = "/";
        }}
      >
        <img
          src="/logo.png"
          alt="NORYQ"
          style={{ height: "36px", width: "auto", display: "block" }}
        />
      </div>
      <DomeGallery
        images={exploreMovies}
        grayscale={false}
        fit={1.1}
        minRadius={80}
        maxVerticalRotationDeg={0}
        segments={35}
        dragDampening={2}
      />
    </div>
  );
}
